import {Component, Inject} from '@angular/core';
import {FieldGroup} from '../../../form-builder/interfaces/FieldGroup';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-global-services-set-time',
  templateUrl: './global-services-set-time.component.html',
  styleUrls: ['./global-services-set-time.component.scss']
})
export class GlobalServicesSetTimeComponent {
  rowToEdit: FieldGroup;
  title: string;

  hours: number;
  minutes: number;
  selectedOption: string;

  public optionsList = [
    {value: '-1', name: 'Before STA'},
    {value: '1', name: 'After STA'}
  ];

  private departureOptions = [
    {value: '-1', name: 'Before Departure'},
    {value: '1', name: 'After Departure'},
  ];

  constructor( private dialogRef: MdDialogRef<GlobalServicesSetTimeComponent>,
               @Inject(MD_DIALOG_DATA) data: {rowToEdit: FieldGroup, title: string}) {
    this.rowToEdit = data.rowToEdit;
    this.title = data.title;
    this.parseTimeOffsets();
    if (this.rowToEdit.schedule_type_parsed === 'Departure') {
      this.optionsList = this.departureOptions;
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
  apply() {
    if (this.title === 'Set the Start Time') this.rowToEdit.start_offset = ((this.hours * 60) + this.minutes) * +this.selectedOption;
    else this.rowToEdit.stop_offset = ((this.hours * 60) + this.minutes) * +this.selectedOption;
    this.dialogRef.close(this.rowToEdit);
  }
  /**
   * parse the time offsets into a useable propertys.
   * @param element Row data
   */
  parseTimeOffsets() {
    if (this.title === 'Set the Start Time') {
      const time = Math.abs(this.rowToEdit.start_offset);
      this.selectedOption = this.rowToEdit.start_offset > 0 ? '1' : '-1';
      this.hours = Math.floor(time / 60);
      this.minutes = time % 60;
    } else {
      const time = Math.abs(this.rowToEdit.stop_offset);
      this.selectedOption = this.rowToEdit.start_offset > 0 ? '1' : '-1';
      this.hours = Math.floor(time / 60);
      this.minutes = time % 60;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/global-service-schedule/components/global-services-set-time/global-services-set-time.component.ts